import script from "./my.vue?vue&type=script&setup=true&lang=js"
export * from "./my.vue?vue&type=script&setup=true&lang=js"

import "./my.vue?vue&type=style&index=0&id=06a8474a&lang=scss"

const __exports__ = script;

export default __exports__